import * as React from 'react';
import classNames from 'classnames';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const styles = require('./styles.pcss');

type Props = {
  columns: any;
};

class SimpleTableHead extends React.Component<Props> {
  render() {
    return (
      <TableHead>
        <TableRow>
          {this.props.columns.map((v: any, i: any) => {
            return (
              <TableCell
                key={`column-${i}`}
                className={classNames(styles.tableHead)}
              >
                {v}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }
}

export default SimpleTableHead;
